import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CryptoTicker from "./components/CryptoTicker";
import Home from "./pages/Home";
import NewsList from "./pages/NewsList";
import NewsDetail from "./pages/NewsDetail";
import { CategoriesIndex, CategoryDetail } from "./pages/Categories";
import Community from "./pages/Community";
import CommunityPostDetail from "./pages/CommunityPostDetail";
import { Login, Register } from "./pages/Auth";
import Profile from "./pages/Profile";
import AdminDashboard from "./pages/AdminDashboard";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import About from "./pages/About";
import { ProtectedRoute, AdminRoute } from "./components/Guard";
import CoinDetail from "./pages/CoinDetail";
import CoinsIndex from "./pages/CoinsIndex";
import Contact from "./pages/Contact";
import ScrollToTop from "./components/ScrollToTop";
import Market from "./pages/Market";
import { ThemeProvider } from "./context/ThemeContext";
import Portfolio from "./pages/Portfolio";
import Projects from "./pages/Projects";
import ProjectApply from "./pages/ProjectApply";
import PublicProfile from "./pages/PublicProfile";
import WalletScanner from "./pages/WalletScanner";
import WhaleTracker from "./pages/WhaleTracker";
import ProfitCalculator from "./pages/ProfitCalculator";
import DcaCalculator from "./pages/DcaCalculator";
import HalvingCountdown from "./pages/HalvingCountdown";
import CoinCompare from "./pages/CoinCompare";
import GasTracker from "./pages/GasTracker";
import MarketSummary from "./pages/MarketSummary";
import Calendar from "./pages/Calendar";
import ForexCalendar from "./pages/ForexCalendar";
import Stocks from "./pages/Stocks";
import StockDetail from "./pages/StockDetail";
import Forex from "./pages/Forex";
import ForexDetail from "./pages/ForexDetail";
import TradingSimulator from "./pages/TradingSimulator";
import ResearchDesk from "./pages/ResearchDesk";
import EditorialPolicy from "./pages/EditorialPolicy";
import { ADS_ENABLED } from "./components/AdBanner";
import Careers from "./pages/Careers";

function Shell() {

  return (
        <div style={{ background: "var(--bg-base)", minHeight: "100vh", color: "var(--text-primary)", overflowX: "hidden", width: "100%" }}>
      <ScrollToTop />
      <Navbar />
      <div className="pt-16">
        <CryptoTicker />
      </div>
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/news" element={<NewsList />} />
          <Route path="/news/:slug" element={<NewsDetail />} />
          <Route path="/categories" element={<CategoriesIndex />} />
          <Route path="/categories/:slug" element={<CategoryDetail />} />
          <Route path="/community" element={<Community />} />
          <Route path="/community/:id" element={<CommunityPostDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/about" element={<About />} />
          <Route path="/coins/:slug" element={<CoinDetail />} />
          <Route path="/coins" element={<CoinsIndex />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/market" element={<Market />} />
          <Route path="/portfolio" element={<ProtectedRoute><Portfolio /></ProtectedRoute>} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/apply" element={<ProjectApply />} />
          <Route path="/profile/:userId" element={<PublicProfile />} />
          <Route path="/tools/wallet-scanner" element={<WalletScanner />} />
          <Route path="/tools/whale-tracker" element={<WhaleTracker />} />
          <Route path="/tools/profit-calculator" element={<ProfitCalculator />} />
          <Route path="/tools/dca-calculator" element={<DcaCalculator />} />
          <Route path="/tools/halving-countdown" element={<HalvingCountdown />} />
          <Route path="/tools/coin-compare" element={<CoinCompare />} />
          <Route path="/tools/gas-tracker" element={<GasTracker />} />
          <Route path="/tools/market-summary" element={<MarketSummary />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/economic-calendar" element={<ForexCalendar />} />
          <Route path="/stocks" element={<Stocks />} />
          <Route path="/stocks/:symbol" element={<StockDetail />} />
          <Route path="/forex" element={<Forex />} />
          <Route path="/forex/:pairSlug" element={<ForexDetail />} />
          <Route path="/trading-simulator" element={<TradingSimulator />} />
          <Route path="/about/research-desk" element={<ResearchDesk />} />
          <Route path="/editorial-policy" element={<EditorialPolicy />} />
          <Route path="/careers" element={<Careers />} />
        </Routes>
      </main>
      <Footer />
      <Toaster theme="dark" position="top-right" />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <Shell />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}